export const APPROVAL_ACTIONS = {
	APPROVE: "APPROVE",
	REJECT: "REJECT",
	UNAPPROVE: "UNAPPROVE",
	OPEN_PENDING: "OPEN_PENDING",
};

export const COMPANY_APPROVAL_TYPES = [
	"basic_details",
	"address_details",
	"financial_details",
	"files",
	"compliance_certificates",
	"contact_details",
	"vendor_agreement",
];

export const FACTORY_APPROVAL_TYPES = [
	"basic_details",
	"address_details",
	"files",
	"compliance_certificates",
	"contact_details",
];

export const getLatestApproval = (rows = [], type) => {
	const filtered = (rows || []).filter((row) => row.type === type);
	if (!filtered.length) return null;
	return [...filtered].sort((a, b) => {
		const aTime = new Date(a.createdAt || a.created_at || 0).getTime();
		const bTime = new Date(b.createdAt || b.created_at || 0).getTime();
		if (bTime !== aTime) return bTime - aTime;
		return (b.id || 0) - (a.id || 0);
	})[0];
};

export const getApprovalHistory = (rows = [], type) => {
	const filtered = (rows || []).filter((row) => row.type === type);
	return [...filtered].sort((a, b) => {
		const aTime = new Date(a.createdAt || a.created_at || 0).getTime();
		const bTime = new Date(b.createdAt || b.created_at || 0).getTime();
		if (aTime !== bTime) return aTime - bTime;
		return (a.id || 0) - (b.id || 0);
	});
};

export const getApprovalStatus = (row) => {
	if (!row) return "Pending";
	if (row.approved || row.action === APPROVAL_ACTIONS.APPROVE) return "Approved";
	if (row.action === APPROVAL_ACTIONS.REJECT) return "Rejected";
	if (row.action === APPROVAL_ACTIONS.UNAPPROVE || row.action === APPROVAL_ACTIONS.OPEN_PENDING) return "Pending";
	// Historical rows without action
	if (row.remark) return "Rejected";
	return "Pending";
};

export const mergeApprovalRow = (rows = [], row) => {
	if (!row) return rows || [];
	const exists = (rows || []).some((item) => item.id === row.id);
	if (exists) return (rows || []).map((item) => (item.id === row.id ? { ...item, ...row } : item));
	return [...(rows || []), row];
};

export const areAllLatestSectionsApproved = (companyData, factories = []) => {
	if (!companyData) return false;
	for (const type of COMPANY_APPROVAL_TYPES) {
		const latest = getLatestApproval(companyData.supplierApproval, type);
		if (!latest?.approved) return false;
	}
	for (const factory of factories || []) {
		for (const type of FACTORY_APPROVAL_TYPES) {
			const latest = getLatestApproval(factory.factoryApproval, type);
			if (!latest?.approved) return false;
		}
	}
	return true;
};
